import { Component } from '@angular/core';
import { CrmProfilePageComponent } from '../crm-components/profile-page/profile-page.component';
import { ObjectType } from '@galaxy/crm/static';

@Component({
  // requires selector to prevent ID collision
  selector: 'crm-contact-profile-page',
  template: ` <crm-profile-page [objectType]="objectType" [previousPageUrl]="'/crm/contact/list'"></crm-profile-page> `,
  providers: [],
  imports: [CrmProfilePageComponent],
})
export class CrmContactProfilePageComponent {
  objectType: ObjectType = 'Contact';
}
